import Receipt from './Receipt.vue'
import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import ReceiptView from "./view/ReceiptView";
import DashboardView from "./view/dashboard/DashboardView";
import InventoryList from "./view/InventoryList";
import Terms from "./view/terms/Terms";
import Notes from "./view/notes/Notes";
import ActivitiesView from "./view/activities/ActivitiesView";
import Attachments from "@/modules/receipt/view/attachments/Attachments";
import ReturnNotesList from "@/modules/receipt/view/return-notes/ReturnNotesList";
import RelationsList from "@/modules/receipt/view/relations/RelationsList";
import VendorCharges from "./view/vendor-charges/VendorCharges";
import Contracts from "@/modules/receipt/view/contracts/Contracts.vue";

const routes = [
  {
    path: 'receipts',
    name: 'receipts',
    component: Receipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'receipts/view/:id',
    component: ReceiptView,
    name: 'receipt.view',
    redirect: 'receipts/view/:id/dashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'receipt.dashboard',
        component: DashboardView
      },
      {
        path: 'inventory',
        name: 'receipt.inventory',
        component: InventoryList
      },
      {
        path: 'notes',
        name: 'receipt.notes',
        component: Notes
      },
      {
        path: 'terms',
        name: 'receipt.terms',
        component: Terms
      },
      {
        path: 'vendorCharges',
        name: 'receipt.vendorCharges',
        component: VendorCharges
      },
      {
        path: 'activities',
        name: 'receipt.activities',
        component: ActivitiesView
      },
      {
        path: 'attachments',
        name: 'receipt.attachments',
        component: Attachments
      },
      {
        path: 'return-notes',
        name: 'receipt.returnNotes',
        component: ReturnNotesList
      },
      {
        path: 'relations',
        name: 'receipt.relations',
        component: RelationsList
      },
      {
        path: 'contracts',
        name: 'receipt.contracts',
        component: Contracts
      },
    ]
  },
];

MenuService.addMenuItem(new MenuItem('/receipts', i18n.t('Receipts'), 3, 'receipt', [], 'view_receipt'));

export {routes}
